import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useSearchParams } from "react-router-dom";
import { useAuth } from "../../../context/auth";
import { useSnackbarAlert } from "../../../context/snackbarAlert";
import { validToken } from "../../../helpers/methods";
import { getErrorMsg, getObjectFromSearchParams, getObjectWithoutKeys } from "../../../helpers/methods";
import useEffectOnce from "../../../hooks/useEffectOnce";
import LoaderWrapper from "../../wrapper/LoaderWrapper";

const MyHomeAuth = () => {
    const { t } = useTranslation();
    const snackbarAlert = useSnackbarAlert();

    const [isLoading, setIsLoading] = useState(true);

    const { myHomeLogin } = useAuth();

    const [searchParams, setSearchParams] = useSearchParams();
    const userToken = searchParams.get("myhome_token");

    useEffectOnce(() => {
        const verifyMyHomeToken = async () => {
            try {
                setSearchParams(getObjectWithoutKeys(getObjectFromSearchParams(searchParams), ["myhome_token"]));
                await myHomeLogin(userToken);
                snackbarAlert.openSuccessSnackbarAlert(t("snackbar_alert.logged_in"));
            } catch (err) {
                snackbarAlert.openErrorSnackbarAlert(
                    getErrorMsg(err.data),
                    t("snackbar_alert.occurred_error_during_logging_in"),
                );
            } finally {
                setIsLoading(false);
            }
        };

        validToken(userToken) ? verifyMyHomeToken() : setIsLoading(false);
    }, []);
    return isLoading ? <LoaderWrapper showLoader={true} /> : <Outlet />;
};

export default MyHomeAuth;
